import { GridExpandMoreIcon, GridRenderCellParams, useGridApiContext } from '@mui/x-data-grid-premium';
import { PressEvent } from 'react-aria-components';
import { AgButton } from 'src/components/ui';
import { cn } from 'src/components/ui/utils';
import { useGridCore } from 'src/providers/GridCoreProvider';

export default function ExpandMore({
  id,
  field,
  rowNode,
  className,
  hideIfNoChildren = true,
  onPress,
}: GridRenderCellParams & { className?: string; hideIfNoChildren?: boolean; onPress?: (event: PressEvent) => void }) {
  const apiRef = useGridApiContext();
  const setGroupExpanded = useGridCore((store) => store.setGroupExpanded);

  if (rowNode.type !== 'group') {
    return null;
  }

  const notExpanded = !rowNode.childrenExpanded;

  if (!rowNode.children && hideIfNoChildren) {
    return null;
  }

  const handlePress = (event: PressEvent) => {
    apiRef.current.setRowChildrenExpansion(id, notExpanded);
    apiRef.current.setCellFocus(id, field);

    setGroupExpanded(rowNode.groupingKey, notExpanded);

    onPress?.(event);
  };

  return (
    <AgButton variant="ghost" size="icon-sm" shape="circle" className={cn('h-7 w-7', className)} onPress={handlePress}>
      <GridExpandMoreIcon
        style={{
          width: '18px',
          height: '18px',
          transform: notExpanded ? 'rotate(-90deg)' : '',
          transition: 'transform 0.2s',
        }}
      />
    </AgButton>
  );
}
